import React, { Component } from "react";

import { connect } from "react-redux";
import { PropTypes } from "prop-types";

import { Redirect } from "react-router-dom";

import { saveCalc } from "../Actions";

import SaveIcon from "./icons/Save";

class SaveButton extends Component {
  constructor() {
    super();

    this.saveOnClick = this.saveOnClick.bind(this);
    this.signupThenSave = this.signupThenSave.bind(this);
    this.saveAndPreview = this.saveAndPreview.bind(this);

    this.state = {
      toView: false,
    };
  }

  saveOnClick() {
    this.props.saveCalc();
  }

  signupThenSave() {
    if (!this.props.authenticator.currentUser) {
      this.props.toggleAuthenticate();
      this.unregisterAuthObserver = this.props.authenticator.onAuthStateChanged(
        (user) => {
          if (user) {
            console.log("now user");
            this.saveAndPreview();
            this.unregisterAuthObserver();
          } else {
            console.log("no user");
          }
        }
      );
    } else {
      this.saveAndPreview();
    }
  }

  saveAndPreview() {
    this.props.saveCalc();
    if (this.props.viewAfterSave) {
      this.setState({
        toView: true,
      });
    }
  }

  render() {
    const { calcKey } = this.props;

    if (this.state.toView) {
      return <Redirect to={`/${calcKey}/view`} />;
    }

    return (
      <button
        style={{
          border: 0,
          backgroundColor: "transparent",
          color: "inherit",
          padding: 0,
          display: "block",
          width: "100%",
          height: "100%",
        }}
        onClick={this.signupThenSave}
      >
        <SaveIcon />
      </button>
    );
  }
}
SaveButton.defaultProps = {
  label: (
    <span>
      Save<span className="display-on-xxl"> your budget</span>
    </span>
  ),
  viewAfterSave: true,
};
const mapStateToProps = (state) => ({
  calcKey: state.calculator.calcKey,
});
const mapDispatchToProps = (dispatch) => ({
  saveCalc: () => {
    console.log("saving to firebase");
    dispatch(saveCalc);
  },
});
SaveButton.contextTypes = {
  store: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(SaveButton);
